























import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { IRepresentative, IPageParams } from '../../models';
import paginationMixin from '@/mixins/pagintation';
@Component({
  components: {
    UIActions: () => import('@/components/UI/Actions.vue'),
  },
  data: () => ({
    namespace: 'representative',
  }),
  mixins: [paginationMixin],
})
export default class RepresentativeList extends Vue {
  @Action('getEntities', { namespace: 'representative' })
  getEntities: () => void;
  @Getter('entitiesSlice', { namespace: 'representative' })
  entitiesSlice: IRepresentative[];
  @State('pageParams', { namespace: 'representative' }) pageParams: IPageParams;
  interval = null;
  headers = [
    { text: 'Фамилия', value: 'last_name' },
    { text: 'Имя', value: 'first_name' },
    { text: 'Отчество', value: 'middle_name' },
    { text: 'Почта', value: 'email' },
  ];
  selected = [];

  created() {
    this.getEntities();
  }
}
